define('OutSystems/ClientRuntime/Database',["require", "exports", "tslib", "./Exceptions", "./Flow", "./Interfaces", "./Logger", "./NativeHelper", "./RegExpHelper"], function (require, exports, tslib_1, Exceptions_1, Flow, Interfaces_1, Logger, NativeHelper, RegExpHelper) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.SqlDbIntrospector = exports.SqlDbProvider = exports.MockSqlDatabaseWithExecution = exports.MockSqlDatabase = exports.TxExecutor = void 0;
    var CanaryQueryError = "Failed to execute canary query (probably due to zombie transaction)";
    var CallbackFunction = (function () {
        function CallbackFunction(callback) {
            this.callback = callback;
        }
        return CallbackFunction;
    }());
    var SuccessCallback = (function (_super) {
        tslib_1.__extends(SuccessCallback, _super);
        function SuccessCallback(callback) {
            var _this = _super.call(this, callback) || this;
            _this.callback = callback;
            return _this;
        }
        return SuccessCallback;
    }(CallbackFunction));
    var ErrorCallback = (function (_super) {
        tslib_1.__extends(ErrorCallback, _super);
        function ErrorCallback(callback) {
            var _this = _super.call(this, callback) || this;
            _this.callback = callback;
            return _this;
        }
        return ErrorCallback;
    }(CallbackFunction));
    var TxExecutor = (function () {
        function TxExecutor(tx, allowTraces) {
            if (allowTraces === void 0) { allowTraces = true; }
            this.tx = tx;
            this.allowTraces = allowTraces;
            this.chain = [];
            this.pendingResult = null;
            this.hasPendingResult = false;
            this.pendingError = null;
            this.hasPendingError = false;
            this.parent = null;
        }
        TxExecutor.prototype.cloneForNext = function () {
            var next = new TxExecutor(this.tx, this.allowTraces);
            next.parent = this;
            return next;
        };
        TxExecutor.prototype.andThen = function (continuation) {
            if (!this.hasPendingError) {
                this.chain.push(new SuccessCallback(continuation));
                this.triggerPendingResults();
            }
            return this;
        };
        TxExecutor.prototype.withoutTraces = function (continuation) {
            return this.andThen(function (runner, result) {
                runner.allowTraces = false;
                return continuation(runner, result);
            });
        };
        TxExecutor.prototype.andThenAll = function (continuations) {
            return this.andThen(function (runner, result) {
                var nextSteps = continuations(result);
                var continuation = runner.feed(undefined);
                if (nextSteps) {
                    for (var i = 0; i < nextSteps.length; i++) {
                        continuation = continuation.andThen(nextSteps[i]);
                    }
                }
                return continuation.andThen(function () { });
            });
        };
        TxExecutor.prototype.extractScalar = function (dbRecord) {
            var keys = Object.keys(dbRecord);
            if (keys.length === 1) {
                var key = keys[0];
                return dbRecord[key];
            }
            else {
                throw new Exceptions_1.Exceptions.DataBaseException("", "Invalid use of 'extractScalar': the row should have a single column, but found '".concat(keys.join("', '"), "'"));
            }
        };
        TxExecutor.prototype.executeScalar = function (sql, args) {
            var _this = this;
            return this.executeQueryRaw(sql, args).andThen(function (runner, result) {
                if (result.rows.length === 0) {
                    return undefined;
                }
                else {
                    return _this.extractScalar(result.rows.item(0));
                }
            });
        };
        TxExecutor.prototype.executeQuery = function (sql, conversionFunction, args) {
            return this.executeQueryRaw(sql, args).andThen(function (runner, result) {
                var converted = new Array(result.rows.length);
                for (var i = 0; i < result.rows.length; i++) {
                    var item = result.rows.item(i);
                    converted[i] = conversionFunction(item);
                }
                return converted;
            });
        };
        TxExecutor.prototype.executeNonQuery = function (sql, args) {
            return this.executeQueryRaw(sql, args).andThen(function (runner, result) {
                return undefined;
            });
        };
        TxExecutor.prototype.executeQueryRaw = function (sql, args) {
            var _this = this;
            var queryId = TxExecutor.queryCount++;
            var argsToLog = args || [];
            this.traceQuery(queryId, sql, argsToLog);
            this.tx.executeSql(sql, args, function (tx, rs) {
                try {
                    _this.continueWithNext(rs);
                }
                catch (e) {
                    _this.abortExplicitly(tx, e);
                }
            }, function (tx, e) {
                _this.trace("SQL command #".concat(queryId, " failed with error ") + e.message);
                return _this.abort(e);
            });
            return this;
        };
        TxExecutor.prototype.feed = function (feed) {
            this.hasPendingResult = true;
            this.pendingResult = feed;
            return this;
        };
        TxExecutor.prototype.onError = function (handler) {
            this.chain.push(new ErrorCallback(handler));
            this.triggerPendingError();
            return this;
        };
        TxExecutor.prototype.nextCallback = function (filterCallback) {
            for (var i = 0; i < this.chain.length; i++) {
                if (filterCallback(this.chain[i])) {
                    var callback = this.chain[i].callback;
                    this.chain = this.chain.slice(i + 1, this.chain.length);
                    return callback;
                }
            }
            return null;
        };
        TxExecutor.prototype.nextErrorCallback = function () {
            return this.nextCallback(function (handler) { return handler instanceof ErrorCallback; });
        };
        TxExecutor.prototype.hasErrorCallback = function () {
            return this.chain.some(function (handler) { return handler instanceof ErrorCallback; });
        };
        TxExecutor.prototype.nextSuccessCallback = function () {
            return this.nextCallback(function (handler) { return handler instanceof SuccessCallback; });
        };
        TxExecutor.prototype.abort = function (e) {
            var onError = this.nextErrorCallback();
            if (onError) {
                this.pendingError = null;
                this.hasPendingError = false;
                try {
                    var shouldAbort_1 = false;
                    var abortCallback = function () {
                        shouldAbort_1 = true;
                    };
                    var result = onError(e, abortCallback);
                    if (shouldAbort_1) {
                        this.chain = [];
                    }
                    else {
                        this.continueWithNext(result);
                    }
                    return shouldAbort_1;
                }
                catch (otherError) {
                    if (this.hasErrorCallback()) {
                        return this.abort(otherError);
                    }
                    else if (this.parent) {
                        return this.parent.abort(otherError);
                    }
                    else {
                        throw otherError;
                    }
                }
            }
            else {
                this.pendingError = e;
                this.hasPendingError = true;
            }
            if (this.parent) {
                return this.parent.abort(e);
            }
            return true;
        };
        TxExecutor.prototype.abortExplicitly = function (tx, e) {
            if (this.abort(e)) {
                tx.executeSql("ABORT_TRANSACTION", null, function () { }, function () { return true; });
            }
        };
        TxExecutor.prototype.continueWithNext = function (result) {
            var _this = this;
            this.hasPendingResult = false;
            if (result instanceof TxExecutor) {
                result.andThen(function (e, r) {
                    _this.continueWithNext(r);
                });
                return;
            }
            else if (result instanceof Array) {
                if (result.length !== 0 && result[0] instanceof TxExecutor) {
                    var i_1 = 0;
                    var runner_1 = function () {
                        if (i_1 < result.length) {
                            result[i_1].andThen(runner_1);
                            i_1++;
                        }
                        else {
                            _this.continueWithNext(result);
                        }
                    };
                    runner_1();
                    return;
                }
            }
            if (this.chain.length > 0) {
                var nextItem = this.nextSuccessCallback();
                if (nextItem) {
                    this.continueWithNext(this.tryNextItem(nextItem, this.cloneForNext(), result));
                    return;
                }
            }
            this.hasPendingResult = true;
            this.pendingResult = result;
        };
        TxExecutor.prototype.tryNextItem = function (nextItem, clone, result) {
            try {
                return nextItem(clone, result);
            }
            catch (e) {
                this.abortExplicitly(this.tx, e);
            }
        };
        TxExecutor.prototype.triggerPendingResults = function () {
            if (!this.hasPendingResult) {
                return;
            }
            this.hasPendingResult = false;
            this.continueWithNext(this.pendingResult);
        };
        TxExecutor.prototype.triggerPendingError = function () {
            if (!this.hasPendingError) {
                return;
            }
            this.hasPendingError = false;
            this.abort(this.pendingError);
        };
        TxExecutor.prototype.trace = function (msg) {
            if (this.allowTraces) {
                Logger.trace(this, msg);
            }
        };
        TxExecutor.prototype.traceQuery = function (queryId, sql, queryArguments) {
            if (this.allowTraces) {
                Logger.trace(this, function () {
                    var queryArgumentsMessage = (queryArguments || []).map(function (argument) {
                        return String(argument).substr(0, 80);
                    });
                    return "Executing SQL command #".concat(queryId, ": ").concat(sql, " with arguments ").concat(queryArgumentsMessage);
                });
            }
        };
        TxExecutor.for = function (tx) {
            return new TxExecutor(tx);
        };
        TxExecutor.queryCount = 0;
        return TxExecutor;
    }());
    exports.TxExecutor = TxExecutor;
    var SqlDatabase = (function () {
        function SqlDatabase(dbName, db) {
            this.dbName = dbName;
            this.db = db;
            this.txCount = 0;
        }
        Object.defineProperty(SqlDatabase.prototype, "name", {
            get: function () {
                return this.dbName;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(SqlDatabase.prototype, "isMock", {
            get: function () {
                return false;
            },
            enumerable: false,
            configurable: true
        });
        SqlDatabase.prototype.executeTransaction = function (body, allowTraces) {
            if (allowTraces === void 0) { allowTraces = true; }
            return this.innerExecuteTransaction(body, false, allowTraces);
        };
        SqlDatabase.prototype.executeReadTransaction = function (body, allowTraces) {
            if (allowTraces === void 0) { allowTraces = true; }
            return this.innerExecuteTransaction(body, true, allowTraces);
        };
        SqlDatabase.prototype.innerExecuteTransaction = function (body, isReadOnly, allowTraces) {
            var _this = this;
            var transactionType = isReadOnly ? "READ" : "WRITE";
            var transactionMethod = isReadOnly ? this.db.readTransaction : this.db.transaction;
            var txId = ++this.txCount;
            return Flow.promise(function (resolve, reject) {
                var value;
                var error;
                _this.trace("Opening local storage ".concat(transactionType, " transaction #").concat(txId, " on database ").concat(_this.name), allowTraces);
                transactionMethod.call(_this.db, function (tx) {
                    _this.trace("Executing local storage ".concat(transactionType, " transaction #").concat(txId, " on database ").concat(_this.name), allowTraces);
                    var continuation = TxExecutor.for(tx).feed(undefined);
                    if (allowTraces) {
                        continuation = continuation.andThen(body);
                    }
                    else {
                        continuation = continuation.withoutTraces(body);
                    }
                    return continuation
                        .andThen(function (runner, result) { return (value = result); })
                        .onError(function (e, abort) {
                        error = e;
                        abort();
                    });
                }, function (e) {
                    error = error || e;
                    var processedError = error && error.message ? error : new Error(error);
                    _this.trace("Rolled back local storage ".concat(transactionType, " transaction #").concat(txId, " on database ").concat(_this.name, ": ").concat(processedError.message), allowTraces);
                    reject(new Exceptions_1.Exceptions.DataBaseException("", processedError.message.toString()));
                    return true;
                }, function () {
                    _this.trace("Committed local storage ".concat(transactionType, " transaction #").concat(txId, " on database ").concat(_this.name), allowTraces);
                    resolve(value);
                });
            });
        };
        SqlDatabase.prototype.testConnection = function () {
            var _this = this;
            var maxCanaryQueries = 5;
            var failCount = 0;
            this.trace("Starting to test on database connections. Performing #".concat(maxCanaryQueries, " test queries."));
            return Promise.all(Array.apply(null, { length: maxCanaryQueries }).map(function (value, index) {
                return new Promise(function (resolve) {
                    _this.executeTransaction(function (runner) {
                        return runner.executeQueryRaw("SELECT 1").onError(function (e, abort) {
                            logCanaryError(e);
                            failCount++;
                        });
                    })
                        .catch(function (error) {
                        logCanaryError(error);
                        failCount++;
                    })
                        .then(function () {
                        resolve();
                    });
                });
            })).then(function () {
                _this.trace("Finished tests on database connections. #".concat(maxCanaryQueries - failCount, " out of #").concat(maxCanaryQueries, " successfull queries."));
            });
        };
        SqlDatabase.prototype.trace = function (msg, allowTraces) {
            if (allowTraces === void 0) { allowTraces = true; }
            if (allowTraces) {
                Logger.trace(this, msg);
            }
        };
        return SqlDatabase;
    }());
    var MockSqlDatabase = (function () {
        function MockSqlDatabase(dbName, db) {
            this.dbName = dbName;
            this.db = db;
        }
        Object.defineProperty(MockSqlDatabase.prototype, "name", {
            get: function () {
                return this.dbName;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(MockSqlDatabase.prototype, "isMock", {
            get: function () {
                return true;
            },
            enumerable: false,
            configurable: true
        });
        MockSqlDatabase.prototype.executeTransaction = function (body, allowTraces) {
            if (allowTraces === void 0) { allowTraces = true; }
            return Flow.resolve();
        };
        MockSqlDatabase.prototype.executeReadTransaction = function (body, allowTraces) {
            if (allowTraces === void 0) { allowTraces = true; }
            return Flow.resolve();
        };
        MockSqlDatabase.prototype.testConnection = function () {
            return Promise.resolve();
        };
        return MockSqlDatabase;
    }());
    exports.MockSqlDatabase = MockSqlDatabase;
    var MockSqlDatabaseWithExecution = (function (_super) {
        tslib_1.__extends(MockSqlDatabaseWithExecution, _super);
        function MockSqlDatabaseWithExecution() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        MockSqlDatabaseWithExecution.prototype.executeTransaction = function (body, allowTraces) {
            if (allowTraces === void 0) { allowTraces = true; }
            body(null);
            return Flow.resolve();
        };
        return MockSqlDatabaseWithExecution;
    }(MockSqlDatabase));
    exports.MockSqlDatabaseWithExecution = MockSqlDatabaseWithExecution;
    function logCanaryError(e) {
        Logger.error("Database", CanaryQueryError);
        if (typeof SQLError !== "undefined" && e instanceof SQLError) {
            Logger.error("Database", "SQLError ".concat(e.code, ": ").concat(e.message));
        }
        else {
            Logger.error("Database", e);
        }
    }
    var COULD_NOT_OPEN_DATABASE_MSG = "Could not open database";
    var SqlDbProviderClass = (function () {
        function SqlDbProviderClass() {
            this.dbCache = {};
        }
        SqlDbProviderClass.prototype.trace = function (msg) {
            Logger.trace(this, msg);
        };
        SqlDbProviderClass.prototype.asSafeDbName = function (dbName) {
            return dbName || "";
        };
        SqlDbProviderClass.prototype.openDb = function (dbName) {
            var _this = this;
            dbName = this.asSafeDbName(dbName);
            return Flow.promise(function (resolve, reject) {
                if (!_this.dbCache[dbName]) {
                    NativeHelper.ensureNativeReady()
                        .then(function () {
                        if (typeof window === "undefined") {
                            return reject(new Exceptions_1.Exceptions.SystemException("Database is only available in the browser/web view"));
                        }
                        var w = window;
                        if (NativeHelper.isRunningOnNative()) {
                            if (w.sqlitePlugin) {
                                _this.trace("Opening database '".concat(dbName, "'"));
                                try {
                                    w.sqlitePlugin.openDatabase({ name: dbName, location: "default" }, function (db) {
                                        if (db) {
                                            _this.trace("Database '".concat(dbName, "' opened successfully"));
                                            _this.dbCache[dbName] = new SqlDatabase(dbName, db);
                                            resolve(_this.dbCache[dbName]);
                                        }
                                        else {
                                            _this.trace("Error opening database '".concat(dbName, "'"));
                                            reject(new Exceptions_1.Exceptions.OpenDatabaseException("".concat(COULD_NOT_OPEN_DATABASE_MSG, " '").concat(dbName, "'")));
                                        }
                                    }, function (e) {
                                        _this.trace("Error opening database '".concat(dbName, "' ") + e.message);
                                        reject(new Exceptions_1.Exceptions.OpenDatabaseException("".concat(COULD_NOT_OPEN_DATABASE_MSG, " '").concat(dbName, "': ").concat(e.message.toString())));
                                    });
                                }
                                catch (e) {
                                    reject(new Exceptions_1.Exceptions.OpenDatabaseException("".concat(COULD_NOT_OPEN_DATABASE_MSG, " '").concat(dbName, "': ").concat(e.message.toString())));
                                }
                            }
                            else {
                                reject(new Exceptions_1.Exceptions.OpenDatabaseException("No database driver available"));
                            }
                        }
                        else if (w.openDatabase) {
                            try {
                                _this.trace("Opening database '".concat(dbName, "'"));
                                var db = w.openDatabase(dbName, "1.0", dbName, 5 * 1024 * 1024);
                                if (db) {
                                    _this.trace("Database '".concat(dbName, "' opened successfully"));
                                    _this.dbCache[dbName] = new SqlDatabase(dbName, db);
                                    resolve(_this.dbCache[dbName]);
                                }
                                else {
                                    _this.trace("Error opening database '".concat(dbName, "'"));
                                    reject(new Exceptions_1.Exceptions.OpenDatabaseException("".concat(COULD_NOT_OPEN_DATABASE_MSG, " '").concat(dbName, "'")));
                                }
                            }
                            catch (e) {
                                reject(new Exceptions_1.Exceptions.OpenDatabaseException("".concat(COULD_NOT_OPEN_DATABASE_MSG, " '").concat(dbName, "': ").concat(e.message.toString())));
                            }
                        }
                        else {
                            var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
                            var isChrome = !!w.chrome;
                            var errorMessage = "Your app requires native access to a Local Storage database that is not available in your browser.\n\nPlease test your app in your mobile device" +
                                (isSafari || isChrome ? "" : ", or use Google Chrome or Safari web browsers") +
                                ".";
                            alert(errorMessage);
                            reject(new Exceptions_1.Exceptions.SystemException(errorMessage));
                        }
                    })
                        .catch(reject);
                }
                else {
                    resolve(_this.dbCache[dbName]);
                }
            });
        };
        SqlDbProviderClass.prototype.mockDb = function (dbName) {
            return Flow.resolve(new MockSqlDatabase(dbName, null));
        };
        return SqlDbProviderClass;
    }());
    exports.SqlDbProvider = new SqlDbProviderClass();
    var SchemaTypeMatchGroups;
    (function (SchemaTypeMatchGroups) {
        SchemaTypeMatchGroups[SchemaTypeMatchGroups["Full"] = 0] = "Full";
        SchemaTypeMatchGroups[SchemaTypeMatchGroups["Type"] = 1] = "Type";
        SchemaTypeMatchGroups[SchemaTypeMatchGroups["Length"] = 3] = "Length";
        SchemaTypeMatchGroups[SchemaTypeMatchGroups["Decimals"] = 5] = "Decimals";
    })(SchemaTypeMatchGroups || (SchemaTypeMatchGroups = {}));
    var schemaTypeRegex = "^([a-z]+)(\\(([0-9]+)(\\,([0-9]+))?\\))?$";
    var SqlDbIntrospectorClass = (function () {
        function SqlDbIntrospectorClass() {
        }
        SqlDbIntrospectorClass.prototype.tableExists = function (db, tableName) {
            return db.executeReadTransaction(function (runner) {
                return runner
                    .executeScalar("SELECT COUNT(*) FROM sqlite_master WHERE type = 'table' AND name = UPPER(?)", [
                    tableName,
                ])
                    .andThen(function (runner, count) { return count !== 0; });
            });
        };
        SqlDbIntrospectorClass.prototype.columnExists = function (db, tableName, columnName) {
            return db
                .executeReadTransaction(function (runner) {
                return runner.executeScalar("SELECT \"".concat(tableName, "\".\"").concat(columnName, "\" FROM \"").concat(tableName, "\" LIMIT 1"));
            })
                .then(function () { return true; })
                .catch(function () { return false; });
        };
        SqlDbIntrospectorClass.prototype.dbTypeFromSchemaType = function (schemaType) {
            schemaType = schemaType || "";
            switch (schemaType.toUpperCase()) {
                case "INTEGER":
                    return Interfaces_1.ClientDB.DBDataType.INTEGER;
                case "BIGINT":
                    return Interfaces_1.ClientDB.DBDataType.LONGINTEGER;
                case "REAL":
                    return Interfaces_1.ClientDB.DBDataType.DECIMAL;
                case "BOOLEAN":
                    return Interfaces_1.ClientDB.DBDataType.BOOLEAN;
                case "TEXT":
                    return Interfaces_1.ClientDB.DBDataType.TEXT;
                case "DATE":
                    return Interfaces_1.ClientDB.DBDataType.DATE;
                case "TIME":
                    return Interfaces_1.ClientDB.DBDataType.TIME;
                case "DATETIME":
                    return Interfaces_1.ClientDB.DBDataType.DATE_TIME;
                case "BLOB":
                    return Interfaces_1.ClientDB.DBDataType.BINARY_DATA;
                default:
                    return Interfaces_1.ClientDB.DBDataType.UNKNOWN;
            }
        };
        SqlDbIntrospectorClass.prototype.pragmaToTableInfo = function (tableName, tableSql, columns) {
            var _this = this;
            tableSql = tableSql || "";
            var hasAutoIncrement = tableSql.search(/INTEGER PRIMARY KEY AUTOINCREMENT/i) >= 0;
            var tableInfo = {
                tableName: tableName,
                idIsAutoNumber: hasAutoIncrement ? Interfaces_1.ClientDB.AutoNumber.YesIfEmpty : Interfaces_1.ClientDB.AutoNumber.No,
                attributes: columns.map(function (row) {
                    var typeMatch = RegExpHelper.matches(row.type, schemaTypeRegex, true).shift();
                    if (typeMatch) {
                        var dbType = _this.dbTypeFromSchemaType(typeMatch.groups[1]);
                        return {
                            name: row.name,
                            columnName: row.name ? row.name.toUpperCase() : null,
                            type: dbType,
                            length: typeMatch.groups[3]
                                ? parseInt(typeMatch.groups[3], 10)
                                : undefined,
                            decimals: typeMatch.groups[5]
                                ? parseInt(typeMatch.groups[5], 10)
                                : undefined,
                            isEntityReference: row.dflt_value === "NULL" && _this.isIdentifierUnderlyingType(dbType),
                            isPrimaryKey: row.pk === 1,
                        };
                    }
                }),
            };
            return tableInfo;
        };
        SqlDbIntrospectorClass.prototype.isIdentifierUnderlyingType = function (dbType) {
            switch (dbType) {
                case Interfaces_1.ClientDB.DBDataType.INTEGER:
                case Interfaces_1.ClientDB.DBDataType.LONGINTEGER:
                case Interfaces_1.ClientDB.DBDataType.TEXT:
                    return true;
                default:
                    return false;
            }
        };
        SqlDbIntrospectorClass.prototype.introspectTableInfo = function (runner, tableName) {
            var _this = this;
            if (!NativeHelper.isRunningOnNative()) {
                return runner.feed(null);
            }
            var tableSql;
            return runner
                .executeScalar("SELECT sql FROM sqlite_master WHERE type = 'table' AND name = '".concat(tableName, "'"))
                .andThen(function (runner, obtainedTableSql) { return (tableSql = obtainedTableSql); })
                .andThen(function (runner, _) {
                return runner.executeQuery("PRAGMA table_info('".concat(tableName, "')"), function (dbRecord) { return dbRecord; });
            })
                .andThen(function (runner, columns) {
                return _this.pragmaToTableInfo(tableName, tableSql, columns);
            });
        };
        return SqlDbIntrospectorClass;
    }());
    exports.SqlDbIntrospector = new SqlDbIntrospectorClass();
});
//# sourceMappingURL=Database.js.map;
